import React from "react"
import illustration from '../images/page16/illustration.svg'

const Page16 = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ height: "100%", background: backgroundColor, color: color }} className="h-100 grid-cols-12 xl:grid-cols-12">
      <div className='col-1'>
      </div>
      <div className='col-5'>
        <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Come funziona Fleet Audit
        </div>
        <div className='lg:mt-4 font-family-acumin font-weight-500 xl:mt-3 lg:font-32 xl:font-28 lg:line-height-40 xl:line-height-38'>
          Ottieni l’accesso alle informazioni<br />sullo stato della tua flotta e su<br />come può diventare elettrica
        </div>
        <div className='lg:mt-3 xl:mt-2 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Una volta raccolti i dati sui viaggi dell’azienda, e averli<br />
          simulati utilizzando un veicolo elettrico, Edison<br />
          fornisce un report che include i KPI riguardanti lo<br />
          stato di salute della flotta e la percentuale di<br />
          veicoli convertibili in elettrico: il primo passo verso<br />
          una mobilità più sostenibile e il contrasto al<br />
          cambiamento climatico.
        </div>
      </div>
      <div className='col-1'>

      </div>
      <div className='col-4'>
        <div className='lg:mt-9 xl:mt-7 text-center'>
          <img src={illustration} alt='Illustration'/>
        </div>
      </div>
    </div>
  )
}

export default Page16
